<template>
<div class='main-container'>
  <div class='container'>
    <nav class="navbar is-transparent">
      <div class="navbar-brand"
           style="padding:0px;">
        <div class="navbar-burger"
             v-on:click="showNav = !showNav"
             :class="{'is-active':showNav}">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="navbarExampleTransparentExample"
           class="navbar-menu" :class="{'is-active': showNav}">
        <div class="navbar-start">
          <div class='navbar-item'
               v-if="breadcrumbs[0]!='home'">
            <router-link tag="button"
                         class="button"
                         to="/home">Каталог</router-link>
          </div>
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <div class="field is-grouped">
              <p class="control">
                <router-link tag="a"
                             class='button is-light'
                             :to="{name:'About'}">Зворотний зв'язок</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <nav class="breadcrumb has-arrow-separator"
         aria-label="breadcrumbs"
         v-if="breadcrumbs.length>1">
      <ul>
        <li v-for="item in breadcrumbs">
          <router-link :to="{name:item}"><span v-if="item in pathnames">{{pathnames[item]['ua']}}</span></router-link>
        </li>
      </ul>
    </nav>
    <div class='section is-fullheight'>
      <p class=" title menu-label is-5"
         v-if="breadcrumbs.length>1"> {{pathnames[breadcrumbs[1]]['ua']}}</p>
      <section class="hero is-large is-bold"
               v-if="breadcrumbs.length==0">
        <router-link to='home'>
          <div class="hero-body"
               style="background-image:url(static/img/natural-gas-863229_1280.jpg); background-size:cover;">
            <div class="container">
              <h1 class="title has-text-white">
                Каталог нафтопромислових розрахунків
              </h1>
            </div>
          </div>
        </router-link>
      </section>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
  <div class='section'></div>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>calculum.cc</strong> 2022. Всі права застережено.
      </p>
    </div>
  </footer>
</div>
</template>

<script>
import {
  pathnames
} from "./router";
import {
  library
} from '@fortawesome/fontawesome-svg-core';
import {
  faAngleUp,
  faHome
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';


export default {
  name: 'App',
  data: function() {
    return {
      pathnames: pathnames,
      rozdily: ['hydro', 'fngp', 'tvg', 'workover', 'drilling', 'equip'],
      showNav: false,
    }
  },
  computed: {
    breadcrumbs: function() {
      let res = this.$route.fullPath.split("/");
      let res2 = [];
      for (let i = 0; i < res.length; i++) {
        if (res[i].replace(' ', '') != '')
          res2.push(res[i]);
      }
      return res2;
    }
  },

}
</script>

<style>
@import "assets/css/mycustomcss.css";
@import "assets/css/frontpage.css";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue